import { Component, OnDestroy, OnInit, signal, inject } from '@angular/core';
import { SideNav } from './domains/shared/components/side-nav/side-nav';
import { Auth } from 'src/app/domains/auth';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/models/appState';
import { NavigationHandlerHelper } from './domains/shared';
import { storeMenuItems } from './store/actions/menu/menu.actions';
import { UserInfo } from './models/users/user.models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  imports: [Auth, SideNav],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})

export class App implements OnInit, OnDestroy {

  readonly title =                                                 signal<string>('pocgenai-front-nossr');
  isLogged =                                                       signal<boolean>(false);
  userDestroyed$:                                                  Subject<void> = new Subject<void>();
  /* 
  * Injections
  */
  private store =                                                  inject(Store<AppState>);
  private navigationHandlerHelper =                                inject(NavigationHandlerHelper);

  ngOnInit(): void {
    
    this.getUserInfo();

    this.navigationHandlerHelper.setupNavigationHandler();

    setTimeout(() => {
      
      this.navigationHandlerHelper.handlePostLoginNavigation();
    }, 50);
  }

  getUserInfo():void{

    this.store.select(appState => appState.User).pipe(takeUntil( this.userDestroyed$ )).subscribe((user: UserInfo) => {
      
      const { username, idTokenClaims } = user || {};

      this.isLogged.set( !!username );

      if(idTokenClaims){

        const { roles } = idTokenClaims || {};
        
        this.storeMenuItems( roles || [] );
      }
    })
  }

  storeMenuItems( roles: string[] ){

    this.store.dispatch(storeMenuItems({ userRoles: roles || [] }));
  } 

  ngOnDestroy(): void {
    
    this.userDestroyed$.next();
    this.userDestroyed$.complete();
  }
}
